import bloomSkill from '../../../assets/landing/bloom-skill.webp';
import boardBuddies from '../../../assets/landing/board-buddies.webp';
import delhiArtCenter from '../../../assets/landing/delhi-art-center.webp';
import paddleCult from '../../../assets/landing/paddle-cult.webp';

interface Event {
  id: number;
  image: string;
  title: string;
  link: string;
}

const events: Event[] = [
  {
    id: 1,
    image: bloomSkill,
    title: 'Bloom Skill',
    link: 'https://bloomskill.zittle.in/'
  },
  {
    id: 2,
    image: boardBuddies,
    title: 'Board Buddies',
    link: 'https://boardbuddiesind.zittle.in/'
  },
  {
    id: 3,
    image: delhiArtCenter,
    title: 'Delhi Art Center',
    link: 'https://delhiartcentre.zittle.in/'
  },
  {
    id: 3,
    image: paddleCult,
    title: 'Paddle Cult',
    link: 'https://paddlecult.zittle.in/'
  }
];

const UpcomingEvents = () => {
  return (
    <section id="events" className="bg-white pt-20 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center md:text-left text-lg font-semibold mb-8 text-[#FF543E] flex items-center justify-center">
          UPCOMING EVENTS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {events.map(event => (
            <a href={event.link} target="_blank" rel="noopener noreferrer" key={event.id}>
              <div className="group relative aspect-[4/3] rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover absolute inset-0 transform group-hover:scale-105 transition-transform duration-300"
                />

                {/* Emerald green gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/70 via-emerald-900/30 to-transparent" />

                {/* Title overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-center">
                  <h3 className="text-2xl font-bold text-white drop-shadow-md">{event.title}</h3>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;
